import { render, staticRenderFns } from "./GeneralDisplayBoxFeed.vue?vue&type=template&id=be84130c&scoped=true&"
import script from "./GeneralDisplayBoxFeed.vue?vue&type=script&lang=js&"
export * from "./GeneralDisplayBoxFeed.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDisplayBoxFeed.vue?vue&type=style&index=0&id=be84130c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be84130c",
  null
  
)

export default component.exports